export default __webpack_public_path__ + "static/media/imagem-fundo-certificado.9519e880.png";